import { addMonths } from 'date-fns';
import { Loading } from '@kiwicom/account-components';
import { getSafeRedirectUrl } from '@kiwicom/account-client-utils';
import type { NextPage } from 'next';

import Login from '../../../src/login/Login';
import useRedirectOnLoggedIn from '../../../src/login/useRedirectOnLoggedIn';
import { getToken, normalizeQueryParam } from '../../../src/util';

type Props = {
  readonly isAuthenticated: boolean;
  readonly reason: string | undefined;
};

const LoginPage: NextPage<Props> = ({ isAuthenticated, reason }) => {
  useRedirectOnLoggedIn();
  return isAuthenticated ? <Loading /> : <Login reason={reason} />;
};

LoginPage.getInitialProps = (ctx) => {
  const token = getToken(ctx);
  let isAuthenticated = token != null;
  const { res } = ctx;
  const { req } = ctx;
  const { reason } = ctx.query;

  if (res != null && ctx.query.auth_token != null && req != null) {
    const url = new URL(req.url, `http://${req.headers.host}`);
    res.setHeader(
      'Set-Cookie',
      `${'ua_session_token'}=${ctx.query.auth_token}; Expires=${addMonths(
        new Date(),
        1,
      ).toUTCString()}; Path=/`,
    );
    const redirectUrl = url.searchParams.get('redirectUrl');
    res.writeHead(302, {
      Location: getSafeRedirectUrl(redirectUrl) ?? url.pathname.replace(/\/login/, ''), // url.pathname will leave /[language]/user
    });
    res.end();
    isAuthenticated = true;
  }

  return {
    isAuthenticated,
    isSecuredPage: false,
    reason: normalizeQueryParam(reason),
  };
};

export default LoginPage;
